exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-vertical-navigation{display:block}adp-vertical-navigation .vertical-nav{font-size:14px}adp-vertical-navigation .vertical-nav li{display:block;padding:5px 0;cursor:pointer;color:#4a4a4a;transition:all .3s ease}adp-vertical-navigation .vertical-nav li.selected,adp-vertical-navigation .vertical-nav li:hover{color:#0e5061;font-weight:600;transition:all .3s ease}adp-vertical-navigation .vertical-nav li.selected span:before,adp-vertical-navigation .vertical-nav li:hover span:before{opacity:1;visibility:visible;transition:opacity .3s ease,visibility .3s ease}adp-vertical-navigation .vertical-nav li span{position:relative;display:block;padding:2px 30px}adp-vertical-navigation .vertical-nav li span:before{content:\"\";position:absolute;top:0;left:0;bottom:0;opacity:0;visibility:hidden;width:4px;height:100%;background-color:#086274;transition:opacity .3s ease,visibility .3s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpVerticalNavigation/adpVerticalNavigation.less
// module id = 600
// module chunks = 0